import React from 'react'
import ChessHeader from 'components/ChessHeader';
import Jumbotron from 'components/Jumbotron';

export default (props) => {

    const { jumbotronData, textsData } = props
    const jumbotronImg = props.data.jumbotronImg.childImageSharp.sizes;

    return(
        <div className="wrapper">
        <Jumbotron jumbotronData={jumbotronData} image={jumbotronImg} />
        <h5>{textsData.text1}</h5><br/>
        <h5>{textsData.text2}</h5><br/>
        <h5>{textsData.text3}</h5><br/>
        <ChessHeader />
        </div>
    );
  }


// WEBPACK FOOTER //
// ./src/pages/softwares/_softwaresLayout.js